import { getDivisionIcon } from '@/components/deprecated/DivisionIcon';
import { Matchdata } from '@/types/match';
import { convertNumberToDivision } from '@/utils/numberToDivision';

type Props = {
  match?: Matchdata;
};

const Title = (props: Props) => {
  return (
    <div className="mb-2 flex items-center gap-x-2">
      <div className="text-lg font-semibold">
        Match <span className="text-muted-foreground">#{props.match?.id}</span>
      </div>
      {props.match?.division && (
        <div className="flex gap-x-1 text-xs font-semibold">
          {getDivisionIcon(props.match?.division)}
          {convertNumberToDivision(props.match?.division)} Division
        </div>
      )}
    </div>
  );
};

export default Title;
